export default __webpack_public_path__ + "static/media/Serie-PS.cdfbdff6.pdf";